const getCurrentScreenOrientation = ()=>{
    const screenOrientation = "u" > typeof window && window.screen.orientation && window.screen.orientation.type ? window.screen.orientation.type.split('-')[0] : void 0;
    return screenOrientation || ("u" > typeof window && window.screen.width >= 1024 ? 'landscape' : 'portrait');
};
const src_getCurrentScreenOrientation = getCurrentScreenOrientation;
export default src_getCurrentScreenOrientation;
